import React from 'react';

const ElementErrorMessage = ({ message, styles }) => (
  <div className="form-error" style={{ marginTop: 4, ...(styles ?? {}) }}>
    {message}
  </div>
);

export default ElementErrorMessage;
